// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__hn225","amprimary":"Error_amprimary__0Wu1V"};